import { $$ } from "./../OO_jquery";
import { getTrackingOrders } from "../../api/services/userService.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { DateTime } from "luxon";
import { getOrderStatus } from "../../api/helpers/orderHelper";
export default {
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    ...mapMutations(["setStoreLoaded"]),
    showActiveOrderLink(order) {
      if (getOrderStatus(order) == 1) {
        return true;
      }
      return false;
    },
    parseDate(value, store) {
      if (value) {
        let mm = DateTime.fromJSDate(new Date(value.seconds * 1000));
        return (
          mm.toFormat("ccc dd MMM") +
          "<span>at</span>" +
          mm.toFormat("h:mm a") +
          "<span>from</span>" +
          store
        );
      } else return store;
    },
    formatPagination() {
      this.$nextTick(() => {
        $$(".VuePagination__pagination-item-prev-page a").text("Prev");
        $$(".VuePagination__pagination-item-next-page a").text("Next");
      });
    },
    initOrders(storeid) {
      var that = this;
      getTrackingOrders(this.user.id, storeid)
        .get()
        .then(
          collection => {
            if (!collection.empty) {
              that.records = collection.size;
              that.formatPagination();
              that.orders.length = 0;
              that.pageOrders.length = 0;
              collection.forEach(doc => {
                that.orders.push(doc.data());
              });
              for (
                let index = 0;
                index <
                (that.perPage < that.orders.length
                  ? that.perPage
                  : that.orders.length);
                index++
              ) {
                const element = that.orders[index];
                that.pageOrders.push(element);
              }
            }
          },
          function (reason) {
            that.insertErrorlog([
              reason.code,
              reason.message,
              that.$router.currentRoute.fullPath
            ]);
            that.redirectToErrorPage();
          }
        );
    },
    paginateCallback(pageNumber) {
      this.pageOrders = [];
      let start = (pageNumber - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
    },
    moreCallback() {
      let start = (this.page - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
      this.page++;
    }
  }
};
